export function sectionScrolling() {
  $('a[href^="#section-"]').click(function(e){
    e.preventDefault();
    var target = '#' + $(this).attr('href').replace('#section-','');
    $.scrollTo($(target), 800, {offset: {top: -$('header').height()}});
  });
}



// WEBPACK FOOTER //
// ./scripts/components/section-scrolling.js